export default __webpack_public_path__ + "img/002d0b4801eb9abe7831273b793f54d8.png";